import React, { Fragment, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {Row, Col, Container} from 'react-bootstrap';

function Footer() {

  const [enterprice, setEnterprice] = useState(false)

  const enterpriceEvent = (value) => {
    //console.log(value);
    if(value === "Empresa"){
      setEnterprice(true)
    }else{
      setEnterprice(false)
    }
  }
  return (
    <Fragment>
      <div className="section pos-ralative"  style={{paddingTop:"0px"}}>
        <section id="contact" className="section pos-relative ovf-hidden fondo-footer">
          <Row>
            <Col md="7" className="fondo-blanco diamonds padSec pad-btm-team pad-contact" style={{padding:"0 130px"}}>
                <div className="dis-table h-100 w-100">
                  <div className="dis-table-cell h-100 w-100">
                    <div className="line">
                      <div className="scol txt-uppercase">
                        <h2 className="line-height-title letter-spacing-3px fw-black mrg-bt-10 fs-60">
                          Contact
                        </h2>
                      </div>

                      <div className="scol">
                        <form id="contacto" action="/nosotros" method="get">
                          <Row>
                            <Col className="padContact" xs={12} md={6}>
                              <div className="input-field text">
                                <input id="name" name="name" type="text" required/>
                                <label htmlFor="name">
                                  Name*
                                </label>
                              </div>
                            </Col >
                            <Col className="padContact" xs={12} md={6}>
                              <div className="input-field text">
                                <input type="text" id="last-name" name="last-name" required/>
                                <label htmlFor="last-name">
                                  Last Name*
                                </label>
                              </div>
                            </Col>
                            <Col className="padContact" xs={12} md={6}>
                              <div className="input-field text">
                                <input type="email" id="email" name="email" required/>
                                <label htmlFor="email">
                                  Email*
                                </label>
                              </div>
                            </Col>
                            <Col className="padContact" xs={12} md={6}>
                              <div className="input-field text">
                                <input type="tel" id="tel" name="tel" required />
                                <label htmlFor="tel">
                                  Phone
                                </label>
                              </div>
                            </Col>
                            <Col className="padContact" xs={12} md={12}>
                            <div className="input-field select">
                                <select name="enterprise" id="enterprise" onChange={e => enterpriceEvent(e.target.value)}>
                                  <option disabled selected style={{display:"none"}}></option>
                                  <option value="Empresa">Company</option>
                                  <option value="Persona">Person</option>
                                </select>
                                <label htmlFor="enterprise">
                                  Company / Person
                                </label>
                              </div>
                            </Col>
                            {
                              (enterprice) ? 
                              <Col className="padContact" xs={12} md={12}>
                              <div className="input-field text">
                                <input type="text" id="enterprise-name" name="enterprise-name"/>
                                <label htmlFor="enterprise-name">
                                  Enterprise name*
                                </label>
                              </div>
                            </Col>
                              :
                              ""
                            }
                            <Col className="padContact" xs={12} md={12}>
                              <div className="input-field textarea">
                                <textarea name="comments" id="comments"  rows="5"></textarea>
                                <label htmlFor="comments">
                                  ¡Tell us more!
                                </label>
                              </div>
                            </Col>
                            <Col className="padContact">
                              <button type="submit" className="btn btn-color-blue">
                                <span>
                                  SEND INFO
                                </span>
                              </button>
                            </Col>
                          </Row>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            <Col md="5" className="diamonds follow-us padSec fondo-negro">
              <div className="line f-us-cont">
                <div className="scol-12 inline-block">
                  <h2 className="mrg-bt-10 letter-spacing-3px mrg-right-60 fw-black ">
                    <span className="title c-white fw-light fs-60">
                      Follow us
                    </span>
                  </h2>
                </div>
                <div className="scol-12 inline-block mrg-bottom-80 pad-bottom-80 linksPD">
                  <div className="social-links">
                    <ul className="pad-all-0 mrg-all-0">
                      <li className="dis-inline-block x:middle mrg-right-20">

                        <div className="button-gradient --ico --black">
                            <a href="https://twitter.com/Dicio_AI" target="_blank" className="--ico --black">
                              <span>
                                <i className="fab fa-twitter"></i>
                              </span>
                            </a>
                        </div>
                      </li>

                      <li className="dis-inline-block x:middle mrg-right-20">
                        <div className="button-gradient --ico --black">
                          <a href="https://www.facebook.com/Dicioai/" target="_blank" className="--ico --black">
                            <span>
                            <i className="fab fa-facebook-f"></i>
                            </span>
                          </a>
                        </div>
                      </li>

                      <li className="dis-inline-block x:middle mrg-right-20">
                        <div className="button-gradient --ico --black">
                        <a href="https://www.linkedin.com/company/dicio-ai/about/" target="_blank" className="--ico --black">
                          <span>
                            <i className="fab fa-linkedin-in"></i>
                          </span>
                        </a>
                        </div>
                      </li>

                      <li className="dis-inline-block x:middle mrg-right-20">
                        <div className="button-gradient --ico --black">
                        <a href="https://www.instagram.com/dicio.ai/" target="_blank" className="--ico --black">
                          <span>
                            <i className="fab fa-instagram"></i>
                          </span>
                        </a>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="scol-12 inline-block mrg-top-80 pad-bottom-80">
                  <a href="/privacy" className="link-gradient c-white mrg-bt-20 dis-inline-block noticeOP">
                    NOTICE OF PRIVACY
                  </a>
                </div>
              </div>
            </Col>
          </Row>

        </section>
      </div>
    </Fragment>
  );
}
export default Footer;
